import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDeleteLensesParams {
  ids: string[];
}

export interface IDeleteLensesResult extends IResult {
}

export class DeleteLensesRequest extends Request<IDeleteLensesParams, IDeleteLensesResult> {
  constructor(ids: string[]) {
    super('deleteLenses', { ids: ids });
  }
}
